import { useState } from "react";
import { coursesList } from "@/data/global_config";
import QuizPage from "@/components/QuizPage";

const Home = () => {
  const courseCode = localStorage.getItem("courseCode");
  const course = coursesList[courseCode];

  const homePage = course?.homePage;
  const moduleId = course?.moduleId || 1; // map course → quiz module

  const [showQuiz, setShowQuiz] = useState(false);
  const [quizResult, setQuizResult] = useState(null);

  if (!homePage) {
    return (
      <div className="p-6 text-red-600">
        Course content not available
      </div>
    );
  }

  return (
    <div className="w-full h-full overflow-y-auto p-3 md:p-2">

      {/* ===== COURSE CONTENT ===== */}
      {!showQuiz && (
        <>
          <iframe
            src={homePage}
            className="h-[80vh] w-full rounded-md border"
          />

 
        </>
      )}



    </div>
  );
};

export default Home;
